/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from '@kpmg-ux/ngx-tax-design-system';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppContext } from 'src/app/models/app-context.model';
import { StorageKey } from 'src/app/models/application-enum.model';
import { ClientService } from 'src/app/project/project-services/client.service';
import { CommonService } from 'src/app/services/common.service';
import { AuthPolicyService } from 'src/app/auth/services/auth-policy.service';

@Injectable({
  providedIn: 'root'
})

export class AppContextService {
  private _appContext: AppContext;

  // Observable sources
  private _storageSetup: BehaviorSubject<boolean>;
  storageSetup$: Observable<boolean>;

  public _appTitle: BehaviorSubject<string>;
  appTitle$: Observable<string>;

  private _refreshOutageMessage: BehaviorSubject<boolean>;
  refreshOutageMessage$: Observable<boolean>;

  constructor(private router: Router, private _http: HttpClient, private _clientService: ClientService,
    private _commonService: CommonService, private _toastrSvc: ToastService,
    private _authPolicyService: AuthPolicyService) {
    this._appContext = {
      applicationType: null
    };
    this._storageSetup = new BehaviorSubject<boolean>(false);
    this.storageSetup$ = this._storageSetup.asObservable();
    this._appTitle = new BehaviorSubject<string>('');
    this.appTitle$ = this._appTitle.asObservable();
    this._refreshOutageMessage=new BehaviorSubject<boolean>(true);
    this.refreshOutageMessage$= this._refreshOutageMessage.asObservable();
  }

  initialize(): void {
    this.initContextInfo();
  }

  initContextInfo(): void {
    this._commonService.getApplicationType().subscribe(response => {
      debugger;
      sessionStorage.setItem(StorageKey.ApplicationType, JSON.stringify(response));
      this._storageSetup.next(true);
    }, error => {
      this._toastrSvc.showToastNotification({ text: 'Initial CALL An error occurred while fetching Application Info.', appearance: 'error', isCloseable: true });
    });
    this.getUserRole();
  }

  getUserRole(): void {
    //this._authPolicyService.getUserRoles().subscribe(response => {
    //  this._asyncsessionStorage.setItem(StorageKey.UserRoles, JSON.stringify(response));
    //});
  }

  refreshOutageMessage():void{
    this._refreshOutageMessage.next(true);
  }
}
